import { render, staticRenderFns } from "./DesktopBalanceCard.vue?vue&type=template&id=c0372b60&scoped=true"
import script from "./DesktopBalanceCard.vue?vue&type=script&lang=js"
export * from "./DesktopBalanceCard.vue?vue&type=script&lang=js"
import style0 from "./DesktopBalanceCard.vue?vue&type=style&index=0&id=c0372b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0372b60",
  null
  
)

export default component.exports